import {
  FreightClass,
  ShipmentLineItemHazmatPackingGroupEnum,
  ProductPackageType,
  ProductPieceType,
  ShipmentLineItemLengthUnitEnum,
  ShipmentLineItemTempUnitEnum,
  ShipmentLineItemWeightUnitEnum
} from '@shipwell/backend-core-singlerequestparam-sdk';
import {
  FreightClass as CorrogoFreightClass,
  HazmatPackingGroup,
  LengthUnit,
  PackagingType,
  PieceType,
  TemperatureUnit,
  WeightUnit
} from '@shipwell/corrogo-sdk';

export const WEIGHT_UNITS: Record<ShipmentLineItemWeightUnitEnum, WeightUnit> = {
  [ShipmentLineItemWeightUnitEnum.Lb]: WeightUnit.Lb,
  [ShipmentLineItemWeightUnitEnum.Kg]: WeightUnit.Kg
};

export const LENGTH_UNITS: Record<ShipmentLineItemLengthUnitEnum, LengthUnit> = {
  [ShipmentLineItemLengthUnitEnum.Cm]: LengthUnit.Cm,
  [ShipmentLineItemLengthUnitEnum.Ft]: LengthUnit.Ft,
  [ShipmentLineItemLengthUnitEnum.In]: LengthUnit.In,
  [ShipmentLineItemLengthUnitEnum.M]: LengthUnit.M
};

export const PACKAGING_TYPES: Record<ProductPackageType, PackagingType> = {
  [ProductPackageType.Bag]: PackagingType.Bag,
  [ProductPackageType.Bale]: PackagingType.Bale,
  [ProductPackageType.Bin]: PackagingType.Bin,
  [ProductPackageType.Box]: PackagingType.Box,
  [ProductPackageType.Bucket]: PackagingType.Bucket,
  [ProductPackageType.Bundle]: PackagingType.Bundle,
  [ProductPackageType.Can]: PackagingType.Can,
  [ProductPackageType.Carton]: PackagingType.Carton,
  [ProductPackageType.Case]: PackagingType.Case,
  [ProductPackageType.Coil]: PackagingType.Coil,
  [ProductPackageType.Crate]: PackagingType.Crate,
  [ProductPackageType.Cylinder]: PackagingType.Cylinder,
  [ProductPackageType.Drum]: PackagingType.Drum,
  [ProductPackageType.FloorLoaded]: PackagingType.FloorLoaded,
  [ProductPackageType.Other]: PackagingType.Other,
  [ProductPackageType.Pail]: PackagingType.Pail,
  [ProductPackageType.Pieces]: PackagingType.Piece,
  [ProductPackageType.Pkg]: PackagingType.Package,
  [ProductPackageType.Plt]: PackagingType.Pallet,
  [ProductPackageType.Reel]: PackagingType.Reel,
  [ProductPackageType.Roll]: PackagingType.Roll,
  [ProductPackageType.Skid]: PackagingType.Skid,
  [ProductPackageType.ToteBin]: PackagingType.ToteBin,
  [ProductPackageType.ToteCan]: PackagingType.ToteCan,
  [ProductPackageType.Tube]: PackagingType.Tube,
  [ProductPackageType.Unit]: PackagingType.Unit
};

export const PIECE_TYPES: Record<ProductPieceType, PieceType> = {
  [ProductPieceType.Bag]: PieceType.Bag,
  [ProductPieceType.Bale]: PieceType.Bale,
  [ProductPieceType.Box]: PieceType.Box,
  [ProductPieceType.Bucket]: PieceType.Bucket,
  [ProductPieceType.Bundle]: PieceType.Bundle,
  [ProductPieceType.Can]: PieceType.Can,
  [ProductPieceType.Carton]: PieceType.Carton,
  [ProductPieceType.Case]: PieceType.Case,
  [ProductPieceType.Coil]: PieceType.Coil,
  [ProductPieceType.Crate]: PieceType.Crate,
  [ProductPieceType.Cylinder]: PieceType.Cylinder,
  [ProductPieceType.Drum]: PieceType.Drum,
  [ProductPieceType.Pail]: PieceType.Pail,
  [ProductPieceType.Package]: PieceType.Package,
  [ProductPieceType.Pieces]: PieceType.Pieces,
  [ProductPieceType.Reel]: PieceType.Reel,
  [ProductPieceType.Roll]: PieceType.Roll,
  [ProductPieceType.Skid]: PieceType.Skid,
  [ProductPieceType.Tube]: PieceType.Tube,
  [ProductPieceType.Package]: PieceType.Package
};

export const FREIGHT_CLASSES: Record<FreightClass, CorrogoFreightClass> = {
  [FreightClass._50]: CorrogoFreightClass._50,
  [FreightClass._55]: CorrogoFreightClass._55,
  [FreightClass._60]: CorrogoFreightClass._60,
  [FreightClass._65]: CorrogoFreightClass._65,
  [FreightClass._70]: CorrogoFreightClass._70,
  [FreightClass._775]: CorrogoFreightClass._775,
  [FreightClass._85]: CorrogoFreightClass._85,
  [FreightClass._925]: CorrogoFreightClass._925,
  [FreightClass._100]: CorrogoFreightClass._100,
  [FreightClass._110]: CorrogoFreightClass._110,
  [FreightClass._125]: CorrogoFreightClass._125,
  [FreightClass._150]: CorrogoFreightClass._125,
  [FreightClass._175]: CorrogoFreightClass._175,
  [FreightClass._200]: CorrogoFreightClass._200,
  [FreightClass._250]: CorrogoFreightClass._250,
  [FreightClass._300]: CorrogoFreightClass._300,
  [FreightClass._400]: CorrogoFreightClass._400,
  [FreightClass._500]: CorrogoFreightClass._500
};

export const HAZMAT_PACKING_GROUPS: Record<ShipmentLineItemHazmatPackingGroupEnum, HazmatPackingGroup> = {
  [ShipmentLineItemHazmatPackingGroupEnum.I]: HazmatPackingGroup.I,
  [ShipmentLineItemHazmatPackingGroupEnum.Ii]: HazmatPackingGroup.Ii,
  [ShipmentLineItemHazmatPackingGroupEnum.Iii]: HazmatPackingGroup.Iii
};

export const TEMPERATURE_UNITS: Record<ShipmentLineItemTempUnitEnum, TemperatureUnit> = {
  [ShipmentLineItemTempUnitEnum.C]: TemperatureUnit.C,
  [ShipmentLineItemTempUnitEnum.F]: TemperatureUnit.F
};
